// extracted by mini-css-extract-plugin
module.exports = {"main":"OrderByAccordion_main__QFew1","value":"OrderByAccordion_value__uDzCH","rotation":"OrderByAccordion_rotation__fdfOe"};